import React, { ReactNode, useEffect, useState } from "react";
import useCurrentUser from "../../hooks/useCurrentUser";
import { ETaskStatus, ITask } from "../../data_models/task";
import { FilledButton, TextButton } from "../common/Button";
import useRouting from "../../hooks/useRouting";
import { TaskEnumTextMapper } from "../../data_models/enumToTextMapper";
import { TiArrowForwardOutline } from "react-icons/ti";
import IconButton from "../common/IconButton";
import { ProjectStatusBatch, TaskStatusBatch } from "../common/StatusBatch";
import { IProject } from "../../data_models/project";
import EditOrCreateProjectLightbox from "../lightboxes/projects/EditOrCreateProjectLightbox";
import { dateToShortReadable } from "../../utils/dateUtils";


interface EmployerProjectsTableProps {
    header: string;
    projects: IProject[];
}

const EmployerProjectsTable: React.FC<EmployerProjectsTableProps> = ({ header, projects: _projects }) => {



    const { goToProjectDetails } = useRouting();

    const [showCreateProjectLightbox, setShowCreateProjectLightbox] = useState(false);

    const [projects, setProjects] = useState<IProject[]>([]);
    useEffect(() => {
        if (_projects && _projects.length > 0) {
            setProjects([..._projects].sort((a, b) => {
                const dateA = a._createdAt ? new Date(a._createdAt).getTime() : 0;
                const dateB = b._createdAt ? new Date(b._createdAt).getTime() : 0;
                return dateB - dateA; // Sort descending (newest first)
            }));
        }
    }, [_projects]);


    return (
        <div className="">
            <p className="body1 font-bold">{header}</p>
            {/* No data available  */}
            {(projects?.length || 0) === 0
                ? <div className="flex flex-col items-center space-y-4">
                    <img
                        src="https://storage.googleapis.com/public-platform-assets/images/no_data.svg"
                        alt="No Data"
                        className="w-1/2"
                    />
                    <p className="body1">You do not have any active projects</p>
                    <FilledButton
                        onClick={() => {
                            setShowCreateProjectLightbox(true);
                        }}>
                        Create new Project
                    </FilledButton>

                </div>
                // Projects available
                : <div className="flex flex-col border border-neutral rounded-md min-w-fit">
                    {/* Header */}
                    <div className="grid grid-cols-6 gap-2 p-2 bg-secondary-100">
                        <p className="body3 font-bold">Created</p>
                        <p className="body3 font-bold col-span-3">Project</p>
                        <p className="body3 font-bold col-span-2">Status</p>
                    </div>

                    {projects.map((project, index) => (
                        <div key={project._id} className="grid grid-cols-6 p-2 border-t border-neutral">
                            <div className="caption2 flex items-center">
                                {project._createdAt ? dateToShortReadable(project._createdAt) : '-'}
                            </div>
                            <div className="caption2 col-span-3 flex items-center">{project.title || '-'}</div>
                            <div className="caption2 col-span-2 flex flex-row justify-between items-center">
                                <ProjectStatusBatch status={project.status} />
                                <TextButton
                                    size='small'
                                    onClick={() => goToProjectDetails(project._id!)}
                                    icon={<TiArrowForwardOutline />}
                                >View Details
                                </TextButton>
                            </div>
                        </div>
                    ))}
                </div>
            }

            {showCreateProjectLightbox && <EditOrCreateProjectLightbox onClose={() => setShowCreateProjectLightbox(false)} />}
        </div >
    );
};




export default EmployerProjectsTable;